/**
 * WerkstattCrossLinkBadge — Issue #500 (LCS Werkstatt Quick-Button)
 * ------------------------------------------------------------------
 * Shown in the Gutachten-Akte header area when `werkstatt_in_anspruch=true`.
 *
 * Two rendering modes:
 *   1. LINKED   — `werkstatt_akte_id` is set: the existing WerkstattCrossLinkCard
 *                 in AkteDetail already renders the chip; this badge renders null
 *                 to avoid duplication.
 *   2. PENDING  — flag is set but no akte linked yet: compact badge
 *                 "LCS Werkstatt in Anspruch genommen".
 *
 * Renders nothing when `werkstatt_in_anspruch` is false/null.
 */

import { Wrench } from 'lucide-react';

interface WerkstattCrossLinkBadgeProps {
  werkstatt_in_anspruch: boolean | null | undefined;
  werkstatt_akte_id: string | null | undefined;
}

export default function WerkstattCrossLinkBadge({
  werkstatt_in_anspruch,
  werkstatt_akte_id,
}: WerkstattCrossLinkBadgeProps) {
  if (!werkstatt_in_anspruch) return null;

  // WerkstattCrossLinkCard already renders a linked chip when werkstatt_akte_id
  // is set — don't duplicate.
  if (werkstatt_akte_id) return null;

  // Pending: flag set but no linked werkstatt akte yet
  return (
    <div data-testid="werkstatt-cross-link-badge" className="flex items-center gap-3 px-3 sm:px-4 py-2 rounded-xl border border-red-200 bg-red-50 text-red-800 text-[13px]">
      <span className="w-8 h-8 rounded-lg bg-red-600 text-white flex items-center justify-center flex-shrink-0">
        <Wrench className="w-4 h-4" />
      </span>
      <span className="flex-1 min-w-0">
        <span className="flex items-baseline gap-2 flex-wrap">
          <span className="text-[11px] font-semibold uppercase tracking-wide opacity-70">Werkstatt</span>
          <span className="text-[13px] font-bold">in Anspruch genommen</span>
        </span>
        <span className="text-[12px] opacity-70 block">
          LCS Werkstatt · Akte wird automatisch verknüpft sobald vorhanden
        </span>
      </span>
    </div>
  );
}
